import hb from 'handlebars'
// @ts-ignore
import JustHandlebarsHelpers from 'just-handlebars-helpers'

import countries from './countries'
const countrycodeToName = (code: string) => {
  return countries.find(country => country.alpha2 === code)?.name
}

const isGermany = (code: string) => {
  return code === 'de'
}

const localizeDate = (date: string) => {
  return new Date(date).toLocaleDateString('de-DE', {})
}

hb.registerHelper('countrycodeToName', countrycodeToName)
hb.registerHelper('isGermany', isGermany)
hb.registerHelper('localizeDate', localizeDate)
JustHandlebarsHelpers.registerHelpers(hb)

export const compileTemplate = (template: string, renderOptions: Record<string, string>) => {
  return hb.compile(template)(renderOptions)
}
